/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//TODO: add other customize vue tool



// WEBPACK FOOTER //
// ./src/common/components/lib/core.js